import { makeAutoObservable } from 'mobx'
import { type Integration } from 'entities/Integrations'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'
import { IntegrationSettingsUsersStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsUsersStore'
import { IntegrationCustomSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCustomSettingsStore'
import { IntegrationSettingsPropertyStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsPropertyStore'
import { PIPEDRIVE_SYNC_CHECKBOX_KEYS } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationPipedriveSettings/lib'
import { IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import { type IPipedriveSettingsDict } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationPipedriveSettings/types'
import { IntegrationTimelineStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationTimelineStore'

export class IntegrationPipedriveSettingsStore {
  private _collapseStore
  private _userStore
  private _customSettingsStore
  private _syncStore
  private _propertyStore
  private _timelineStore

  constructor(integration: Integration, private _entities: IEntitiesStore) {
    this._collapseStore = new IntegrationCollapseSettingsStore()
    this._userStore = new IntegrationSettingsUsersStore(integration, this._entities)
    this._customSettingsStore = new IntegrationCustomSettingsStore<IPipedriveSettingsDict>(
      integration,
      this._entities
    )
    this._syncStore = new IntegrationSettingsSyncStore(
      integration,
      this._customSettingsStore,
      PIPEDRIVE_SYNC_CHECKBOX_KEYS
    )
    this._propertyStore = new IntegrationSettingsPropertyStore(
      integration,
      this._customSettingsStore,
      this._entities
    )
    this._timelineStore = new IntegrationTimelineStore(this._entities, 'pipedrive')
    makeAutoObservable(this)
  }

  init = () => {
    this._userStore.init()
    this._customSettingsStore.init1_0()
    this._syncStore.init()
    this._propertyStore.init()
    this._timelineStore.init()
  }

  get collapseStore() {
    return this._collapseStore
  }

  get userStore() {
    return this._userStore
  }

  get syncStore() {
    return this._syncStore
  }

  get propertyStore() {
    return this._propertyStore
  }

  get timelineStore() {
    return this._timelineStore
  }
}
